import { render, staticRenderFns } from "./CallWindow.vue?vue&type=template&id=6a50946c&scoped=true"
import script from "./CallWindow.vue?vue&type=script&lang=js"
export * from "./CallWindow.vue?vue&type=script&lang=js"
import style0 from "./CallWindow.vue?vue&type=style&index=0&id=6a50946c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a50946c",
  null
  
)

export default component.exports